import { en, type Translations } from './en';
import { fr } from './fr';
import { es } from './es';
import { de } from './de';

export type Language = 'en' | 'fr' | 'es' | 'de';

export const translations: Record<Language, Translations> = {
  en,
  fr,
  es,
  de,
};

export const languageNames: Record<Language, string> = {
  en: 'English',
  fr: 'Francais',
  es: 'Espanol',
  de: 'Deutsch',
};

export type { Translations };
export { en, fr, es, de };
